{
  "投诉与意见反馈": "Complaints and feedback",
  "投诉与意见处理": "Complaints and feedback management",
  "主题": "Subject",
  "重新加载资料": "Reload details",
  "搜索主题或详细描述": "Search subject or description",
  "业务投诉": "Business complaint",
  "产品建议": "Product suggestion",
  "运营意见": "Operations feedback",
  "合作申请": "Cooperation application",
  "其他问题": "Other issue",
  "反馈类型": "Feedback type",
  "优先级": "Priority",
  "普通": "Normal",
  "紧急": "Urgent",
  "处理状态": "Handling status",
  "待处理": "Pending",
  "处理中": "In progress",
  "已解决": "Resolved",
  "已关闭_feedback": "Closed",
  "最近处理": "Last handled",
  "处理": "Handle",
  "处理投诉与意见": "Handle complaint or feedback",
  "反馈详情": "Feedback details",
  "提交处理": "Submit response",
  "反馈编号": "Feedback ID",
  "提交 IP": "Submission IP",
  "操作 IP": "Action IP",
  "提交账号": "Submitted by account",
  "详细描述": "Description",
  "处理记录": "Activity",
  "平台回复": "Platform response",
  "商家确认": "Merchant confirmation",
  "商家提交": "Merchant submission",
  "商家补充": "Merchant follow-up",
  "反馈处理已更新": "Feedback response saved",
  "请选择处理状态": "Select a handling status",
  "关闭后不可继续回复。": "Closed feedback cannot receive further replies.",
  "处理回复": "Response",
  "请填写处理回复": "Enter a response",
  "处理回复最多 1800 字": "Response must be at most 1,800 characters",
  "图片附件": "Image attachments",
  "图片已上传": "Image uploaded",
  "图片上传准备失败，请重试": "Could not prepare the image. Please try again.",
  "最多 9 张，JPG / PNG / WebP，单张最大 {{size}} MB": "Up to 9 JPG / PNG / WebP images, {{size}} MB each",
  "最多 9 张，JPG / PNG / WebP": "Up to 9 JPG / PNG / WebP images",
  "反馈图片": "Feedback images",
  "反馈图片 #{{id}}": "Feedback image #{{id}}"
}
